export const TIMEZONES = [
  'Etc/UTC',

  'America/Adak',
  'America/Anchorage',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Denver',
  'America/Boise',
  'America/Chicago',
  'America/New_York',
  'America/Detroit',
  'America/Indiana/Indianapolis',
  'America/Honolulu',

  'America/Vancouver',
  'America/Edmonton',
  'America/Regina',
  'America/Winnipeg',
  'America/Toronto',
  'America/Montreal',
  'America/Halifax',
  'America/St_Johns',

  'America/Tijuana',
  'America/Hermosillo',
  'America/Chihuahua',
  'America/Mazatlan',
  'America/Mexico_City',
  'America/Monterrey',
  'America/Cancun',

  'America/Guatemala',
  'America/Belize',
  'America/Costa_Rica',
  'America/Panama',
  'America/Havana',
  'America/Jamaica',
  'America/Nassau',
  'America/Puerto_Rico',
  'America/Santo_Domingo',
  'America/Barbados',

  'America/Bogota',
  'America/Lima',
  'America/Caracas',
  'America/Santiago',
  'America/La_Paz',
  'America/Asuncion',
  'America/Argentina/Buenos_Aires',
  'America/Sao_Paulo',
  'America/Montevideo',

  'Europe/London',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Brussels',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Zurich',
  'Europe/Vienna',
  'Europe/Prague',
  'Europe/Rome',
  'Europe/Stockholm',
  'Europe/Oslo',
  'Europe/Copenhagen',
  'Europe/Warsaw',
  'Europe/Budapest',
  'Europe/Zagreb',
  'Europe/Belgrade',
  'Europe/Sofia',
  'Europe/Bucharest',
  'Europe/Athens',
  'Europe/Helsinki',
  'Europe/Kyiv',
  'Europe/Istanbul',
  'Europe/Moscow',

  'Africa/Casablanca',
  'Africa/Abidjan',
  'Africa/Lagos',
  'Africa/Algiers',
  'Africa/Tunis',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Nairobi',

  'Asia/Jerusalem',
  'Asia/Beirut',
  'Asia/Baghdad',
  'Asia/Riyadh',
  'Asia/Tehran',
  'Asia/Dubai',
  'Asia/Kabul',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Dhaka',
  'Asia/Colombo',
  'Asia/Yangon',
  'Asia/Bangkok',
  'Asia/Ho_Chi_Minh',
  'Asia/Singapore',
  'Asia/Jakarta',
  'Asia/Manila',
  'Asia/Hong_Kong',
  'Asia/Shanghai',
  'Asia/Taipei',
  'Asia/Seoul',
  'Asia/Tokyo',

  'Australia/Perth',
  'Australia/Darwin',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Sydney',
  'Australia/Hobart',
  'Australia/Lord_Howe',

  'Indian/Mauritius',
  'Indian/Maldives',
  'Indian/Reunion',
  'Indian/Chagos'
] as const;
